module.exports = __webpack_public_path__ + "fonts/memnYaGs126MiZpBA-UFUKWiUNhkIqOjjg.ef9a4320.woff2";